
/**
 * 응답 데이터
 * @nullable
 */
export type GetTerms200AllOfData = { [key: string]: unknown } | null;
